// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3E7QI","choiceBoxes":"toolbarselects_choiceBoxes__21cgX","simpleField":"toolbarselects_simpleField__1wj_u"};